import { render, staticRenderFns } from "./SectionNavigationNew.vue?vue&type=template&id=4e81af95&scoped=true&"
import script from "./SectionNavigationNew.vue?vue&type=script&lang=ts&"
export * from "./SectionNavigationNew.vue?vue&type=script&lang=ts&"
import style0 from "./SectionNavigationNew.vue?vue&type=style&index=0&id=4e81af95&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e81af95",
  null
  
)

export default component.exports